export default __webpack_public_path__ + "static/media/Walt_Disney.935486f7.jpg";